import { render, staticRenderFns } from "./questionEditor.vue?vue&type=template&id=5385878e&scoped=true"
import script from "./questionEditor.vue?vue&type=script&lang=js"
export * from "./questionEditor.vue?vue&type=script&lang=js"
import style0 from "./questionEditor.vue?vue&type=style&index=0&id=5385878e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5385878e",
  null
  
)

export default component.exports